import { request, tokenStorageKey } from '@/api/userAuth'

export function beginLoginTransfer(transfer) {
  localStorage.removeItem(tokenStorageKey)
  window.dispatchEvent(new CustomEvent('weijie-login-transfer'))
  // Source proof stays in this tab; it is never included in a redirect URL.
  sessionStorage.setItem(`login-source:${transfer.id}`, transfer.proof)
  window.location.replace(transfer.url)
}

export async function completeLoginTransfer() {
  const params = new URLSearchParams(window.location.hash.slice(1))
  const stage = ['start', 'authorize', 'finish'].find(key => params.has(key))
  const id = params.get(stage)
  const challenge = params.get('challenge')
  window.history.replaceState(null, '', '/login/transfer')
  if (!stage || !/^[a-f0-9]{64}$/.test(id || '')) throw new Error('登录跳转已失效，请重新登录')
  const payload = { id, stage }
  if (stage === 'start') {
    const verifier = Array.from(crypto.getRandomValues(new Uint8Array(32)), n => n.toString(16).padStart(2, '0')).join('')
    sessionStorage.setItem(`login-target:${id}`, verifier)
    const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
    payload.challenge = Array.from(new Uint8Array(hash), n => n.toString(16).padStart(2, '0')).join('')
  } else if (stage === 'authorize') {
    payload.proof = sessionStorage.getItem(`login-source:${id}`) || ''
    payload.challenge = challenge
    sessionStorage.removeItem(`login-source:${id}`)
  } else {
    payload.verifier = sessionStorage.getItem(`login-target:${id}`) || ''
    sessionStorage.removeItem(`login-target:${id}`)
  }
  const data = await request('login-transfer', payload)
  if (data.url) { window.location.replace(data.url); return null }
  return data
}
